var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"mode":"out-in","name":"accordion-fade"}},[(_vm.showMessage)?_c('CollapseCard',{staticClass:"mb-2",attrs:{"is-alert":true}},[_c('h3',{attrs:{"slot":"title-text"},slot:"title-text"},[_vm._v("Kommentar från handläggare")]),_c('template',{slot:"body-text"},[_c('p',[_vm._v(_vm._s(_vm.message))])])],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }